export const SIDEBAR_ACTIVE = "SIDEBAR_ACTIVE";
export const SETTINGS_ACTIVE = "SETTINGS_ACTIVE";
export const PROFILE_ACTIVE = "PROFILE_ACTIVE";
export const THEME = "THEME";
export const NOTIFICATION = "NOTIFICATION";
export const MESSAGE = "MESSAGE";
